/**
 * Отправить событие в google Analytics DataLayer
 * @example Send some event
 * addGoogleEvent({
 *      event: 'SMEReg',
 *      eventDescription: 'LandingEmailStart',
 *      eventCategory: 'Interactions',
 *      eventAction: 'Start',
 *      eventLabel: 'Email'
 *    });
 * @param event
 */
function addGoogleEvent(event) {
  if (window.dataLayer && typeof window.dataLayer.push === 'function') {
    window.dataLayer.push(event);
  }
}

window.addGoogleEvent = addGoogleEvent;

module.exports = {
  addGoogleEvent: addGoogleEvent // eslint-disable-line
};
